import "./App.css";
import React, { useEffect } from "react";
import Dashboard from "./components/v2/Dashboard";
// import SignInForm from "./components/SignInForm";
import SignInForm from "./components/v2/SignInForm";
import Communications from "./components/communications/Communications";
import ProofFund from "./components/ProofFund";
// import MyAccount from "./components/MyAccount";
import MyAccount from "./components/v2/MyAccount";

import SendReport from "./components/communications/SendReport";
import PrivacyPolicy from "./components/PrivacyPolicy";
import HostedUiRedirect from "./components/HostedUiRedirect";
import HostedUiRedirectNewUser from "./components/HostedUiRedirectNewUser";
import SignUpNewAccount from "./components/SignUpNewAccount";
// import GuestReport from "./components/GuestReport";
import GuestReport from "./components/v2/GuestReport";

import NewUserSignIn from "./components/NewUserSign";
import ProcessComplete from "./components/ProcessComplete";
import RequestComplete from "./components/RequestComplete";
// import StripeComplete from "./components/StripeComplete";
import ClientList from "./components/v2/ClientList";
import DealDetails from "./components/v2/DealDetails";
import RentalPropertyList from "./components/v2/RentalPropertyList";
import MarketingManager from "./components/v2/MarketingManager";
import MarketingSessionDetail from "./components/v2/MarketingSessionDetail";
import AdminDashboard from "./components/v2/AdminDashboard";
import AdminUserManagement from "./components/v2/AdminUserManagement";
import AdminUsers from "./components/v2/AdminUsers";
import AdminZillowListing from "./components/v2/AdminZillowListing";
import AdminDealProgramManager from "./components/v2/AdminDealProgramManager";
import AdminDealList from "./components/v2/AdminDealList";
import AdminDealDetail from "./components/v2/AdminDealDetail";
import AdminInboundReview from "./components/v2/AdminInboundReview";
import AdminAnalytics from "./components/v2/AdminAnalytics";
import AdminSiteConfig from "./components/v2/AdminSiteConfig";

import {
  Switch,
  Route,
  BrowserRouter,
  Redirect,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Auth } from "aws-amplify";
import { addToken } from "./actions/addToken";
import { expireSession } from "./utils/sessionExpiry";
import { getHostedUiToken } from "./utils/hostedUiToken";
import { makeStyles } from "@material-ui/core/styles";
import LayoutRoute from "./components/v2/global/components/LayoutRoute";
import AdminLayoutRoute from "./components/v2/global/components/AdminLayoutRoute";
import StripeComplete from "./components/v2/StripeComplete";
import SetPassword from "./components/v2/SetPassword";

const withStyles = makeStyles(() => ({
  App: {
    textAlign: "center",
  },
  App_logo: {
    height: "40vmin",
    pointerEvents: "none",
  },
  App_root: {
    background: "linear-gradient(-9deg, #46a7ba 0%, #1faa60 100%)",
    minHeight: "100vh",
    // display: "flex",
    // flexDirection: "column",
    // alignItems: "center",
    // justifyContent: "center",
    fontSize: "calc(10px + 2vmin)",
    color: "white",
    // paddingBottom: "5rem",
  },
}));

function App() {
  const token = useSelector((state) => state.token);
  const dispatch = useDispatch();
  const classes = withStyles();

  useEffect(() => {
    if (token) {
      return;
    }
    const pathname = window.location.pathname;
    const isWhitelisted =
      pathname === "/" ||
      pathname === "/policy" ||
      pathname === "/newusersignin" ||
      pathname.startsWith("/guest") ||
      pathname.startsWith("/client") ||
      pathname.startsWith("/deals");
    if (isWhitelisted) {
      return;
    }
    let cancelled = false;
    Auth.currentSession()
      .then((session) => {
        if (!cancelled) {
          dispatch(addToken(session.getIdToken().getJwtToken()));
        }
      })
      .catch(() => {
        if (!cancelled && !getHostedUiToken()) {
          expireSession();
        }
      });
    return () => {
      cancelled = true;
    };
  }, [token, dispatch]);

  return (
    <div className={classes.App}>
      <div className={classes.App_root}>
        <BrowserRouter>
          <Switch>
            {/* <Route
              path="/dashboard"
              render={() => <Dashboard title="Dashboard" />}
            /> */}

            {/* <Route
              path="/dashboard"
              render={() => (
                <Layout>
                  <Dashboard title="Dashboard" />
                </Layout>
              )}
            /> */}

            <LayoutRoute
              path="/dashboard"
              component={Dashboard}
              title="Dashboard"
            />

            <Route path="/communications" component={Communications} />
            <Route path="/prooffund" component={ProofFund} />
            {/* <Route path="/myaccount" component={MyAccount} /> */}
            {/* <Route path="/myaccount" component={MyAccount} /> */}

            <LayoutRoute path="/myaccount" component={MyAccount} />

            {/* <Route exact path="/" component={SignInForm} />   old*/}
            <Route exact path="/" component={SignInForm} />

            {/* <Route path="/signin" component={SignInForm} /> */}
            <Route path="/policy" component={PrivacyPolicy} />
            {/* <Route path="/signup" component={SignUpForm} /> */}
            <Route path="/newaccount" component={SignUpNewAccount} />
            <Route path="/newusersignin" component={NewUserSignIn} />
            <Route path="/hosteduiredirect" component={HostedUiRedirect} />
            <Route
              path="/hosteduiredirectnewuser"
              component={HostedUiRedirectNewUser}
            />
            {/* <Route path="/guest/:id/:pin" component={GuestReport} /> */}
            <Route path="/guest/:id/:pin" component={GuestReport} />

            <Route
              path="/sendreport/guest/:id/:pin"
              render={() => <SendReport title="Communications" guest="true" />}
            />
            <Route
              path="/sendreport"
              render={() => <SendReport title="Communications" />}
            />

            <Route path="/processcomplete" component={ProcessComplete} />
            <Route path="/requestcomplete" component={RequestComplete} />

            {/* Admin Routes */}
            <Redirect exact from="/admin" to="/admin/dashboard" />
            <AdminLayoutRoute path="/admin/dashboard" component={AdminDashboard} />
            <AdminLayoutRoute path="/admin/users" component={AdminUsers} />
            <AdminLayoutRoute path="/admin/invitations" component={AdminUserManagement} />
            <AdminLayoutRoute path="/admin/hitl/zillow" component={AdminZillowListing} />
            <AdminLayoutRoute path="/admin/hitl/deals/all/:id" component={AdminDealDetail} />
            <AdminLayoutRoute path="/admin/hitl/deals/all" component={AdminDealList} />
            <AdminLayoutRoute path="/admin/hitl/deals" component={AdminDealProgramManager} />
            <AdminLayoutRoute path="/admin/hitl/inbound" component={AdminInboundReview} />
            <AdminLayoutRoute path="/admin/analytics" component={AdminAnalytics} />
            <AdminLayoutRoute path="/admin/site-config" component={AdminSiteConfig} />
            <Redirect from="/hilstaff" to="/admin/dashboard" />

            {/* <Route
              path="/stripe_success"
              render={() => <StripeComplete success={true} />}
            /> */}

            <Route path="/set_password" render={() => <SetPassword />} />

            <Route
              path="/stripe_success"
              render={() => <StripeComplete success={true} />}
            />
            <Route
              path="/stripe_error"
              render={() => <StripeComplete success={false} />}
            />
            {/* <Route path="/client-list" component={ClientList} /> */}
            <LayoutRoute path="/client-list" component={ClientList} />
            <LayoutRoute path="/deals/:id" component={DealDetails} />

            <LayoutRoute
              path="/rental-properties"
              component={RentalPropertyList}
            />

            <LayoutRoute path="/marketing/:id" component={MarketingSessionDetail} />
            <LayoutRoute path="/marketing" component={MarketingManager} />

            <Route
              render={() => {
                window.location.href = "/";
                return null;
              }}
            />
          </Switch>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
